import React, { forwardRef } from 'react';

const CustomDatePickerInput = ({ className, value, onClick, onChange, placeholder, disabled }, ref) => {
  return (
    <input
      className={className}
      type="text"
      placeholder={placeholder}
      value={value}
      ref={ref}
      onChange={(e) => onChange(e.target.value)}
      onClick={onClick}
      disabled={disabled}
      readOnly
    />
  );
};

export default forwardRef(CustomDatePickerInput);
